import './PaymentMethodItem.scss';
import ErrorBoundary from './ErrorBoundary';

const { CheckBox, PaymentIcon, Tooltip, Icon } = require('@paymongo/seeds');

interface isPaymentMethodItem {
  checked: Boolean;
  className: string;
  disabled?: boolean;
  hidden?: boolean;
  icon: string;
  label: string;
  onChange?: Function;
}

const PaymentMethodItem = ({ checked, className, icon, label, onChange, disabled, hidden = false }: isPaymentMethodItem) => {
  return (
    <div className={`${className} payment-method-item__container --mb-0 --p-lg`} hidden={hidden} >
      <CheckBox
        className="payment-method-item__check-box"
        checked={checked}
        disabled={disabled}
        label={label}
        onChange={() => onChange && onChange(!checked)}
      />
      {
        disabled && <Tooltip
          children={<span><Icon className="payment-method-item__question-icon" icon="infoCircle" size="sm" /></span>}
          content={<p className="text --md --mb-0">Reach out to support@paymongo.com</p>}
          position="bottom-left"
          invert
        />
      }
      <ErrorBoundary>
        <PaymentIcon className="payment-method-item__payment-icon" icon={icon} />
      </ErrorBoundary>
    </div>
  );
}

export default PaymentMethodItem;
